// components
import SvgIconStyle from '../../../components/SvgIconStyle';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import ContentPasteGoIcon from '@mui/icons-material/ContentPasteGo';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import SettingsIcon from '@mui/icons-material/Settings';
import ListAltIcon from '@mui/icons-material/ListAlt';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import LockPersonIcon from '@mui/icons-material/LockPerson';
// ----------------------------------------------------------------------

const getIcon = (name) => <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />;

let routeType = 1;
const sidebarConfig = [
    // GENERAL
    // ----------------------------------------------------------------------

    {
        subheader: 'Yönetim Paneli', menuid: "-1", routeType: routeType,path:'/',
        items: [
            {
                title: 'İçerik Yönetimi', menuid: "1", routeType: routeType,
                path: 'icerik',
                icon: <SettingsIcon></SettingsIcon>,
                roles: ["User"],
                children: [
                    { title: 'İçerik Ekle/Güncelle', path: '/icerik/blogpost', icon: <SettingsIcon></SettingsIcon>, menuid: "11", routeType: routeType, },
                    { title: 'SabitSayfalar  SEO Ekle/Güncelle', path: '/icerik/sabitsayfalarseo', icon: <SettingsIcon></SettingsIcon>, menuid: "12", routeType: routeType, }
                   
                ],
            },



            {
                title: 'Kullanıcı Yönetimi', menuid: "2", routeType: routeType,
                path: 'UserManagement',
                icon: <SettingsIcon></SettingsIcon>,
                roles: ["Admin"],
                children: [
                    { title: 'Kullanıcı Ekle/Güncelle', path: '/UserManagement/UserManagement', icon: <SettingsIcon></SettingsIcon>, menuid: "21", routeType: routeType, },
                ],
            },  
            {
                title: 'Formlar', menuid: "3", routeType: routeType,
                path: 'FormYonetimi',
                icon: <SettingsIcon></SettingsIcon>,
                roles: ["User"],
                children: [
                    { title: 'Kirala Satın Al Başvurular', path: '/kiralasatinal/basvurular', icon: <SettingsIcon></SettingsIcon>, menuid: "31", routeType: routeType, },
                    { title: 'Kurumsal Araç Kiralama Başvurular', path: '/kurumsalarackiralama/basvurular', icon: <SettingsIcon></SettingsIcon>, menuid: "32", routeType: routeType, },
                    { title: 'Rent Go Filo Başvurular', path: '/rentgofilo/basvurular', icon: <SettingsIcon></SettingsIcon>, menuid: "33", routeType: routeType, }
                ],
            },
            {
                title: 'Ayarlar Yönetimi', menuid: "4", routeType: routeType,
                path: 'Anahtarlar',
                icon: <SettingsIcon></SettingsIcon>,
                roles: ["Admin"],
                children: [
                    { title: 'Anahtar Ekle/Güncelle', path: '/DataSettings/DataSettings', icon: <SettingsIcon></SettingsIcon>, menuid: "41", routeType: routeType, },
                    { title: 'Mobil Uygulama Ayarları', path: '/DataSettings/AppConfigSettings', icon: <SettingsIcon></SettingsIcon>, menuid: "42", routeType: routeType, roles: ["Admin"] },
                ],
            },
            {
                title: 'Kupon Kodu Yönetimi', menuid: "5", routeType: routeType,
                path: 'CouponCodeManagement',
                icon: <SettingsIcon></SettingsIcon>,
                roles: ["User"],
                children: [
                    { title: 'Kupon Kodu Ekle/Güncelle', path: '/CouponCodeManagement/CouponCodeManagement', icon: <SettingsIcon></SettingsIcon>, menuid: "51", routeType: routeType, },
                ],
            },


            {
                title: 'Acente Yönetimi', menuid: "6", routeType: routeType,
                path: 'Acenteler',
                icon: <SettingsIcon></SettingsIcon>,
                roles: ["Admin"],
                children: [
                    { title: 'Acente Bilgileri', path: '/Acente/AcenteLists', icon: <SettingsIcon></SettingsIcon>, menuid: "61", routeType: routeType, },
                ],
            },
            {
                title: 'Müşteri Yönetimi', menuid: "7", routeType: routeType,
                path: 'Musteriler',
                roles: ["CallCenter"],
                icon: <SettingsIcon></SettingsIcon>,
                children: [
                    { title: 'Musteri Bilgileri', path: '/MusteriYonetimi/Musteriler', icon: <SettingsIcon></SettingsIcon>, menuid: "71", routeType: routeType, },
                ],
            },

            //     {
            // title: 'Kullanıcı&Rol&Yetki',
            // path: 'admin',
            // icon: <LockPersonIcon></LockPersonIcon>,menuid:"27",routeType:routeType,
            // children: [
            //   // { title: 'Roller', path: '/tanimlamalar/role',menuid:"17",routeType:routeType, },
            //   // { title: 'Role Menu Ekle/Çıkar', path: '/tanimlamalar/rolemenu' ,menuid:"21",routeType:routeType,},
            //   { title: 'Kullanıcı', path: '/tanimlamalar/user2',menuid:"10",routeType:routeType, },
            //   { title: 'Kullanıcı  Ekle/Çıkar', path: '/tanimlamalar/userrole2' ,menuid:"29",routeType:routeType,}
            // ]
            // }
        ],
    },
];

export default sidebarConfig;
